import { AccountInfo } from "@azure/msal-common"

export default class User {
  account: any | undefined

  constructor(msalAccount: AccountInfo) {
    this.account = msalAccount.idTokenClaims
  }

  get userId() {
    return this.account?.sub
  }

  get emailAddress() {
    return this.account?.email
  }

  get firstName() {
    return this.account?.given_name
  }

  get lastName() {
    return this.account?.family_name
  }

  get topCode() {
    return this.account?.extension_tourOperatorCode
  }

  get roles() {
    return this.account?.extension_userRoles?.split(',')
  }

  get locale() {
    return this.account?.extension_userLocale
  }

  get isFetching() {
    return this.account?.isFetching
  }
}
